/* Slow editorial marquee — signature line without exposing platforms */
const WORDS = [
  "Premium Co-Hosting",
  "Boutique Hospitality",
  "Flere bookinger",
  "Passiv indkomst",
  "Sæby · Danmark",
  "Est. 2026",
  "Hotel-standard",
  "Fuldt hands-off",
];

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="bg-white border-y border-black/10 overflow-hidden py-6 sm:py-8"
      aria-hidden="true"
    >
      <div className="marquee-track-slow flex whitespace-nowrap">
        {[...WORDS, ...WORDS, ...WORDS].map((w, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-8 px-8 font-serif text-[#111111]/85 text-[7vw] sm:text-[4.5vw] lg:text-[3.5vw] leading-none tracking-tight"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            <span className="italic font-light">{w}</span>
            <span
              aria-hidden="true"
              className="inline-block w-3 h-3 rounded-full bg-[#D4AF37] shrink-0"
            />
          </span>
        ))}
      </div>
    </section>
  );
}
